<template>
  <el-aside class="aside-container hide-scrollbar" style="position: relative" :class="{ 'collapse-aside': foldRobot, 'expend-aside': !foldRobot, 'isMobile': isMobile }">

    <!-- 头部区域：包含 logo 和操作图标 -->
    <div class="aside-header" :class="foldRobot ? 'collapse-aside-header' : ''">
      <div class="logo-area">
        <div class="logo" />
        <span class="logo-text">&nbsp;探数蚁</span>
      </div>

      <!-- 操作按钮区域 -->
      <div class="header-actions">
        <div class="option aside-fold" @click="collapseAside" v-if="foldRobot">
          <tooltip-image placement="bottom" content="展开侧栏">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 20" class="btn-icon btn-img">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.5 3h15m-8 7h8m-8 7h8m-15-7 3.484 3.5L2.5 17"></path>
            </svg>
          </tooltip-image>
        </div>

        <div class="option aside-expend" @click="collapseAside" v-if="!foldRobot">
          <tooltip-image placement="bottom" content="收起侧栏">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 20" class="btn-icon btn-img">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 3h-15m8 7h-8m8 7h-8m15-7-3.484 3.5L17.5 17"></path>
            </svg>
          </tooltip-image>
        </div>

        <div class="option history-option" @click="handleHistoryPanel" :class="foldHistory ? 'history-fold' : 'history-expend'" v-show="foldHistory">
          <tooltip-image placement="bottom" content="历史记录">
            <svg class="btn-icon history-btn btn-img" :width="isMobile ? 36 : 16" :height="isMobile ? 36 : 16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="Group 427324713">
                <g id="Group 427324714">
                  <path id="Icon" d="M2.21936 7.89625C2.21936 4.37005 5.07866 1.51149 8.60578 1.51149C12.1329 1.51149 14.9922 4.37005 14.9922 7.89625C14.9922 11.4225 12.1329 14.281 8.60578 14.281C6.2419 14.281 4.17799 12.997 3.07375 11.0886M3.97133 7.19559L2.37473 8.79178L0.778126 7.19559" stroke="#1A2029" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path id="Icon_2" d="M10.6492 9.3024L8.25488 8.50431V5.16711" stroke="#1A2029" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </g>
            </svg>
          </tooltip-image>
        </div>
      </div>
    </div>

    <div class="aside-subjects" :class="foldRobot ? 'collapse-aside-subjects' : ''">
      <div class="subjects">
        <template v-for="robot in robots">

          <!-- ★ 新增：带着地图学习入口（复用 knowledgeGraph 的位置：组卷与数学水平之间） -->
          <div v-if="robot.id === 'knowledgeGraph'" key="kgEntry" class="subject kg-entry" @click="openAdvanced">
            <el-tooltip content="带着地图学习" placement="right" :disabled="!foldRobot">
              <!-- ★ 红点：包一层相对定位容器，流完成后（有未读）显示 -->
              <span class="kg-icon-wrap">
                <img class="subject-icon" :src="robot.avatar" />
                <span class="kg-unread-dot" v-if="kgUnread"></span>
              </span>
            </el-tooltip>
            <div class="subject-text">&nbsp;带着地图学习
              <!-- ★ 展开态：红点跟在文字后 -->
              <span class="kg-unread-dot kg-unread-dot--text" v-if="kgUnread"></span>
            </div>
          </div>

          <!-- 我的错题本：展开状态下点击可展开/收起子菜单（无箭头） -->
          <div v-if="robot.id === 'wrong' && !foldRobot && !(robot.isShow && robot.isShow === 'no')"
               :key="robot.id" class="subject wrongbook-parent" @click="toggleWrongbook">
            <img class="subject-icon" :src="robot.avatar" />
            <div class="subject-text">&nbsp;{{ robot.name }}</div>

            <!-- 子菜单紧贴下方 -->
            <div v-show="showWrongbook" class="wrongbook-sub-items">
              <div class="wrongbook-sub" @click.stop="openWrongBook('exercises')">
                <div class="item-content">
                  <i class="el-icon-reading" style="color: rgb(41, 186, 253);"></i>
                  <span class="item-title">高中错题本</span>
                </div>
              </div>
              <div class="wrongbook-sub" @click.stop="openWrongBook('mexercises')">
                <div class="item-content">
                  <i class="el-icon-reading" style="color: #f7ba2a;"></i>
                  <span class="item-title">初中错题本</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 我的错题本：折叠状态下点击直接加载高中错题本（默认） -->
          <div v-else-if="robot.id === 'wrong' && foldRobot && !(robot.isShow && robot.isShow === 'no')"
               :key="robot.id" class="subject" @click="openWrongBook('exercises')">
            <el-tooltip :content="robot.name" placement="right">
              <img class="subject-icon" :src="robot.avatar" />
            </el-tooltip>
          </div>

          <!-- 其他智能体（包括我的收藏本等） -->
          <div v-else-if="!(robot.isShow && robot.isShow === 'no')"
               :key="robot.id" class="subject"
               :class="robotId === robot.id ? 'selected' : ''"
               @click="choosedRobot(robot.id)">
            <el-tooltip :content="robot.name" placement="right" :disabled="!foldRobot">
              <img class="subject-icon" :src="robot.avatar" />
            </el-tooltip>
            <div class="subject-text">&nbsp;{{ robot.name }}</div>
            <div v-show="robot.id === 'mathLevel' && score !== '' && !foldRobot">
              <ul class="math-ul">
                <li style="margin: 0 auto;">
                  <el-tag class="math-level">{{ score }}</el-tag>
                </li>
              </ul>
            </div>
            <div @click.stop="() => { }" v-if="robot.id === 'collect' && !foldRobot" class="collect-section">
              <collect :showCollect="showCollect" :isMobile="isMobile"></collect>
            </div>
          </div>

        </template>
      </div>

      <div class="el-overlay" style="z-index: 2004; display: none">
        <div role="dialog" class="el-overlay-dialog"></div>
      </div>
      <div class="el-overlay" style="z-index: 2005; display: none">
        <div role="dialog" class="el-overlay-dialog"></div>
      </div>
    </div>

    <AdvancedLearning v-if="showAdvanced"
                      :kg-id="advancedKgId"
                      :paint-data="advancedPaintData"
                      :level="currentLevel"
                      @close="onAdvancedClose" />
  </el-aside>
</template>

<script>
import store from "@/store/index";
import "@/assets/font/iconfont.css";
import TooltipImage from "../TooltipImage.vue";
import userUrl from "@/assets/image/user.svg";
import chatMixin from "@/mixin/chat.js";
import robotMixin from "@/mixin/robot.js";
import pubsub from "pubsub-js";
import collect from "@/components/chat/collect"
import AdvancedLearning from "@/components/AdvancedLearning.vue";
import { showGraphNames, showGraph } from "@/api/chat/knowledgeGraph";
import { mapState } from "vuex";
// ★ 新增：backgroundFlow 的订阅 + 未读状态接口（模块级单例，弹窗内的流完成会通知到这里）
import { subscribe, hasUnseenFlows } from "@/utils/learning/backgroundFlow";

export default {
  components: { TooltipImage, collect, AdvancedLearning },
  data() {
    return {
      userUrl,
      showCollect: false,
      showWrongbook: false,
      showAdvanced: false,
      advancedKgId: "",
      advancedPaintData: null,
      currentLevel: "",
      kgUnread: false, // ★ 新增：图谱学习入口红点（有已完成未读的流 → true）
    };
  },
  mounted() {
    pubsub.subscribe("fold", (msg, data) => {
      this.foldRobot = data;
    });

    // ★ 新增：订阅 backgroundFlow 状态变化
    // 任何流到达终态（完成/失败）→ service notify → 刷新红点
    this._unsubKgFlow = subscribe(() => {
      this.kgUnread = hasUnseenFlows();
    });
    // 页面刷新后从 sessionStorage 恢复红点状态
    this.kgUnread = hasUnseenFlows();
  },
  beforeDestroy() {
    // ★ 新增：取消订阅，防内存泄漏
    this._unsubKgFlow && this._unsubKgFlow();
  },
  mixins: [chatMixin, robotMixin],
  computed: {
    ...mapState([
      "robotId", "robots", "messageStorage", "user", "sessionId",
      "foldHistory", "robotSessionMap", "foldRobot", "isMobile"
    ]),
  },
  methods: {
    // ★ 打开图谱学习弹层
    // ★ 打开图谱学习弹层（空参打开，由弹窗自行恢复最新现场）
    // 从具体图谱跳转进入的场景仍由外部传 :kg-id / :paint-data，不受影响
    async openAdvanced() {
        // 用户主动进入 → 红点立即熄灭（弹窗 mounted 的 clearUnseenFlows 负责持久化熄灭）
        this.kgUnread = false;
        // 由当前智能体反推学段（弹窗内部有同样的兜底映射）
        const ROBOT_LEVEL = { exercises: "h", mexercises: "m", pexercises: "p" };
        this.currentLevel = ROBOT_LEVEL[this.robotId] || "";
        // ★ 不再预加载图谱、不再传 advancedKgId/advancedPaintData：
        // 弹窗 mounted 会拉取列表并自动加载"有进行中流/有快照/有未读完成"的最新图谱
        this.showAdvanced = true;
        // 移动端收起侧栏，避免弹层与抽屉重叠
        if (this.isMobile) store.commit("SET_FOLDROBOT", true);
    },
    onAdvancedClose() {
      this.showAdvanced = false;
      this.advancedPaintData = null;
      this.advancedKgId = "";
      // ★ 关闭弹窗后同步一次红点状态（弹窗 mounted 已 clearUnseenFlows，此处兜底）
      this.kgUnread = hasUnseenFlows();
    },
    initRobotId() {
      for (const key in this.robots) {
        if (this.$route.path.includes(this.robots[key].id)) {
          store.commit("setRobotId", this.robots[key].id);
        }
      }
    },
    collapseAside() {
      if (this.isMobile) {
        store.commit("SET_FOLDHISTORY");
      }
      store.commit("SET_FOLDROBOT", !this.foldRobot);
    },
    handleHistoryPanel() {
      if (this.isMobile) {
        store.commit("SET_FOLDROBOT");
      }
      store.commit("SET_FOLDHISTORY", !this.foldHistory);
    },
    toggleWrongbook() {
      this.showWrongbook = !this.showWrongbook;
    },
    // 打开错题本：不在这里直接发布事件，而是先切换智能体，
    // 把"要加载什么"挂到 store，等切换完成后由 chatMain 执行
    openWrongBook(targetRobotId) {
      store.commit('SET_PENDING_ACTION', { type: 'wrong' });
      if (this.robotId !== targetRobotId) {
        this.choosedRobot(targetRobotId);
      } else {
        this.execPendingAction();
      }
      if (this.isMobile) {
        store.commit('SET_FOLDROBOT', true);
      }
    },
    // 执行并清空待办动作（错题本场景：只处理 wrong；其他类型走 mixin 完整分发）
    execPendingAction() {
      const pending = store.state.pendingAction;
      if (!pending) return;
      store.commit('SET_PENDING_ACTION', null);

      if (pending.type === 'wrong') {
        pubsub.publish('getQuestionList', { type: 'wrong' });
      } else {
        store.commit('SET_PENDING_ACTION', pending);
        switch (pending.type) {
          case 'getGraph':
            pubsub.publish('getGraph', { kgid: pending.kgid, level: pending.level });
            break;
          case 'getPaper':
            pubsub.publish('getPaper', { paper: pending.paper });
            break;
          case 'getTopic':
            pubsub.publish('getTopic', pending.topic);
            break;
          default:
            pubsub.publish('getQuestionList', { type: pending.type });
        }
      }
    },
  },
  created() {
    store.commit("SET_MESSAGESTORAGE");
    store.commit("INIT_ROBOTSESSIONMAP");
    this.initRobotId();
  },
  watch: {
    $route(to, from) {
      for (const key in this.robots) {
        if (to.path.includes(key)) {
          store.commit("setRobotId", key);
        }
        if (from.path.includes("login")) {
          if (Object.keys(this.messageStorage).length === 0) {
            store.commit("SET_MESSAGESTORAGE");
            this.initRobotId();
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* { margin: 0; padding: 0; box-sizing: border-box; }

.aside-container {
  background-color: var(--leftbox-bg-color);
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--border-page);
  color: #333;
  box-sizing: border-box;
  width: 240px !important;
  padding: 5px 12px 0 12px;
  align-items: center;
  position: relative;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;

  .aside-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 3px;
    box-sizing: border-box;
    width: 100%;
    z-index: 1;
    color: var(--txt-default-color);
    padding-top: 10px;
    margin-bottom: 16px;

    .logo-area {
      display: flex;
      width: fit-content;
      align-items: center;
      line-height: 32px;
      .logo {
        width: 40px;
        height: 40px;
        background-size: 40px 40px;
        background-image: url("/logo.png");
        border-radius: 8px;
      }
      span {
        margin-left: 5px;
        font-size: 16px;
        font-weight: 600;
      }
    }

    .header-actions {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-shrink: 0;
      .option {
        cursor: pointer;
        display: flex;
        align-items: center;
        svg {
          width: 18px;
          height: 18px;
        }
      }
      .history-option {
        // 无额外样式
      }
    }
  }

  .aside-subjects {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    margin-bottom: 10px;
    width: 100%;
    height: calc(100vh - 55px);
    overflow-y: auto;
    overflow-x: hidden;

    .subjects {
      &:first-child { margin-top: 0; }
      .subject {
        display: flex;
        flex-wrap: wrap;
        padding: 6px 8px;
        align-items: center;
        position: relative;
        cursor: pointer;

        .subject-text {
          overflow: hidden;
          white-space: nowrap;
          pointer-events: none;
          text-overflow: ellipsis;
          color: var(--txt-default-color-2);
          text-align: left;
          font-size: 13px;
          line-height: 20px;
          margin-left: 12px;
        }
        .subject-icon {
          width: 28px;
          height: 28px;
        }
        .el-tooltip { vertical-align: baseline; }
        &:hover {
          border-radius: 8px;
          background: var(--hover-bg-color-1);
        }
        &:has(.collect-section) { height: 40px; }
      }
      .subject+.subject { margin-top: 6px; }
    }
  }
}

// ================= ★ 图谱学习入口红点 =================
.kg-icon-wrap {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}
.kg-unread-dot {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #f56c6c;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.85);
  animation: kg-dot-blink 1.2s ease-in-out infinite;
  pointer-events: none;
  z-index: 1;
}
// 展开态：跟在「带着地图学习」文字后的红点（内联小圆点）
.kg-unread-dot--text {
  position: static;
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-left: 4px;
  box-shadow: none;
  vertical-align: middle;
}
@keyframes kg-dot-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

// 折叠面板
.collapse-aside {
  width: 44px !important;
  padding: 6px;
  .collapse-aside-header {
    flex-direction: column;
    padding-left: 0;
    padding-top: 12px;
    .logo-area {
      .logo-text { display: none; }
    }
    .header-actions {
      margin-top: 10px;
      gap: 8px;
      flex-direction: column;
      align-items: center;
    }
  }
  .collapse-aside-subjects {
    .subjects {
      margin-top: 6px;
      .subject {
        padding: 3px 3px;
        .subject-text { display: none; }
      }
    }
  }
}

.selected {
  border-radius: 8px;
  background: var(--robot-bg-color);
}

::v-deep .el-dropdown-menu__item {
  width: 5rem !important;
  text-align: center;
}

.math-ul {
  list-style: none;
  margin-left: 2.8rem;
  .math-level {
    width: 80px;
    text-align: center;
  }
}

.fold {
  width: 58px;
  padding: 6px;
  .text { display: none; }
  .robot-list {
    padding: 0 !important;
    padding-top: 5px !important;
    ul { margin: 0 auto; }
  }
  header {
    padding: 0 !important;
    padding-top: 16px !important;
    flex-direction: column;
    align-items: center;
    i { margin-top: 16px; }
    img { padding-right: 0; }
  }
}

::v-deep .el-popover__reference {
  display: inline-block;
  width: 140px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.btn-img {
  path {
    stroke: var(--txt-default-color);
    color: var(--txt-default-color);
    transition: stroke 0.3s ease;
  }
  &:hover {
    path { stroke: var(--txt-color-blue); }
  }
}

// ================= 错题本样式（参照收藏本二级菜单） =================
.wrongbook-parent {
  flex-wrap: wrap !important;
  margin-top: 6px;
}

.wrongbook-sub-items {
  width: 100%;
  padding-left: 48px;
  margin-top: 4px;
}

.wrongbook-sub {
  cursor: pointer;
  margin-top: 2px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;
  &:hover {
    background: rgba(0, 0, 0, 0.05);
    transform: translateX(2px);
    .item-content .item-title {
      color: $base_green;
    }
  }
  .item-content {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    width: 100%;
    box-sizing: border-box;
    i {
      font-size: 16px;
      color: #6c757d;
      flex-shrink: 0;
    }
    .item-title {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 13px;
      color: var(--txt-default-color-2);
    }
  }
}

// 移动端样式
.isMobile {
  .aside-container {
    display: none;
    padding: 0;
    overflow: hidden;
    .subjects {
      width: 100%;
      height: 90vh;
      overflow-y: scroll;
      .subject {
        justify-content: center;
        align-items: center;
        padding: 5px 5px 4px !important;
        line-height: 1;
        width: 90% !important;
        &:hover { border-radius: 8px; }
        &:has(.collect-section) { height: auto; }
      }
    }
    .collapse-aside { padding: 0; }
  }

  .aside-header {
    padding-top: 0.2rem;
    margin-bottom: 0.2rem;
    .logo {
      width: 0.3rem !important;
      height: 0.3rem !important;
      background-clip: border-box;
      background-size: contain !important;
      background-repeat: no-repeat;
      margin-left: 3px;
    }
    .logo-text { font-size: 0.3rem !important; }
    .header-actions { display: none; }
  }

  .collapse-aside { width: 0.6rem !important; }

  .subject-icon {
    width: 0.3rem !important;
    height: 0.3rem !important;
  }

  .options {
    justify-content: center !important;
    .option { margin-left: 18px; }
  }
}

// 移动端展开样式
.isMobile.expend-aside {
  display: block;
  font-size: 0.36rem;

  .logo {
    width: 0.8rem !important;
    height: 0.8rem !important;
    background-size: 0.8rem 0.8rem !important;
  }

  .math-ul {
    width: 80%;
    margin-left: 1.7em;
  }

  &.aside-container {
    margin: 0 auto;
    position: relative;
    left: 0;
    top: 0;
    height: 100vh !important;
    width: 100vw !important;
    z-index: 1000;
    padding-right: clamp(0.5rem, 30px, 0.6rem);

    .aside-header { position: relative; }

    .header-actions {
      display: flex;
      position: absolute;
      right: 0.2rem;
      top: 0.3rem;
      z-index: 1001;
      gap: 12px;
      .option svg { width: 0.4rem; height: 0.4rem; }
    }

    .aside-subjects {
      width: 100%;
      align-items: center;
      .subjects {
        margin-left: 0.8rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        overflow-y: auto;
        overflow-x: hidden;
        height: calc(100vh - 3rem);
        overflow: auto;
        .subject {
          padding: 5px;
          width: fit-content;
          justify-content: flex-start;
          .subject-icon {
            width: 0.4rem !important;
            height: 0.4rem !important;
          }
          .subject-text { font-size: clamp(12px, 0.18rem, 20px); }
          .collect-section { padding-top: 0.25rem; }
        }
      }
    }

    .history-option { display: none; }
  }
}

// 错题本移动端适配
.isMobile {
  .wrongbook-sub-items {
    padding-left: 0.6rem;
    .wrongbook-sub {
      .item-content {
        padding: 8px 12px;
        gap: 10px;
        i { font-size: 18px; }
        .item-title { font-size: 0.9em; }
      }
    }
  }
}
</style>
